/**
 * Convert an amount to locale-formatted currency string
 */
export const convertToLocale = ({
  amount,
  currency_code,
}: {
  amount: number;
  currency_code: string;
}): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency_code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

/**
 * Convert amount to TWD formatted string
 */
export const convertToTwd = (amount: number): string =>
  convertToLocale({
    amount,
    currency_code: 'TWD',
  });
